import { CLOTH_RAIL_OUTSIDE_CONNECTOR_KEY, InteriorComponent } from '@inter-ikea-storageone/range';
import {
  HierarchyUtils,
  Entity,
  GuestConnectionsComponent,
  ComponentIds
} from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { removeProducts } from 'rangeConfig/shared/utils/removeProducts';

const removeAllInteriorsFromSelectedFrame = ({
  coreApi,
  rootState: {
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();

  if (!selectedEntity) {
    return null;
  } else {
    const interiorsProducts = HierarchyUtils.hierarchy(selectedEntity).filter(
      (child: Entity) =>
        child.hasComponent(InteriorComponent.id) &&
        !child
          .getComponent<GuestConnectionsComponent>(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)
          ?.connections.some(c => c.hostConnector.key.includes(CLOTH_RAIL_OUTSIDE_CONNECTOR_KEY))
    );

    if (interiorsProducts) {
      removeProducts(interiorsProducts, coreApi, products);
    }
  }
};

export default removeAllInteriorsFromSelectedFrame;
